import { Deserializable } from "../shared/models/deserializable.model";
import { Business } from './business';

export class Product implements Deserializable {
   accountId: number;
   id: number;
   name: string;
   description: string;
   rate: number;
   quantity: number;
   taxRate: number;
   hasTax: boolean;
   businessId: number;
   Business: Business;

   deserialize(input: any) {
   	Object.assign(this, input);

      // Map Business to Model
      if (input.Business)
         this.Business = new Business().deserialize(input.Business);

      return this;
  }

  getRate() {
     return this.rate / 100;
  }

  getSubTotal() {
     return (this.rate / 100) * this.quantity;
  }

  getTotal() {
     if (this.hasTax) {
        // Add Tax
        return ((this.rate / 100) * this.quantity) * (1+(this.taxRate/100));
     }
     else {
        return (this.rate / 100) * this.quantity;
     }
  }

  totalPreview(rate, qty, hasTax, taxRate) {
     if (hasTax) {
        // Add Tax
        return ((rate / 100) * qty) * (1+(taxRate/100));
     }
     else {
        return (rate / 100) * qty;
     }
  }
}